import React from 'react';
import classnames from 'classnames/bind';
import { SyncAltIcon } from 'tuui';
import { RealizeConnect } from '../icons/RealizeConnect';
import { getPlatformIcon, THIRD_PARTY_PLATFORM } from '../utils/3p-platforms';
import styles from '../pages/thirdPartyConnect.module.scss';

const classNameBuilder = classnames.bind(styles);

export const IconsList = ({ platform }) => {
    // Fallback to WordPress for testing when platform is undefined
    const platformCode = platform || THIRD_PARTY_PLATFORM.WORDPRESS;
    const PlatformIcon = getPlatformIcon(platformCode);

    return (
        <div className={classNameBuilder('icon-list')}>
            <RealizeConnect />
            <SyncAltIcon />
            <PlatformIcon width={40} height={40} />
        </div>
    );
};
